export default "__VITE_ASSET__D3xtdUb1__"